import application from 'application/application';

application

	.value('validationFeedbacks', {
		invalid: [
			{
				type: 'required',
				feedback: 'Campo obrigatório.'
			},
			{
				type: 'number',
				feedback: 'Número inválido.'
			},
			{
				type: 'mail',
				feedback: 'Email inválido.'
			},
			{
				type: 'equals',
				feedback: 'O valor não corresponde com o valor do campo principal.'
			},
			{
				type: 'document',
				feedback: 'Documento inválido.'
			},
			{
				type: 'size',
				feedback: 'Limite de caracteres atingido.'
			}
		]
	});
